import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-building-white',
  templateUrl: './icon-building-white.component.html',
  styles: []
})
export class IconBuildingWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
